import * as React from 'react';
import { imgPath } from '../../../../common/utils/ImgUrl';
import { View } from '../../../models/SearchResultTypes';
import { CardViewStyles } from '../CardViewStyles';
import { ContentCard, getContentUrlForItem } from '../ContentCard';
import { Thumbnail } from '../Thumbnail';
import { classNames } from '../../../../../homepage/Utils';
import { Messages } from '../../../../../gen-src/Localize';
import { CommonStyles } from '../../../../common/styles/CommonStyles';
import { ViewTooltip } from '../tooltips/ViewTooltip';
import { EntityLink, UserEntityLink } from '../../tooltips/elements/EntityLink';
import { ConnectedFavoriteToggle } from '../../Favorites/FavoriteToggle';
import { FeatureFlag, FeatureFlagService } from '../../../services/FeatureFlagService';

export const ViewDefaultImageUrl = imgPath('spaces_card_view.svg');

export const ViewCardTestID = 'ViewCard';
export const ViewCardSubSectionTestID = 'ViewCardSubSection';

export class ViewCard extends ContentCard {
  public render() {
    const viewInfo = this.props.content as View;
    return (
      <div className={classNames(CardViewStyles.Card)}>
        <Thumbnail
          navigateUrl={getContentUrlForItem(viewInfo)}
          defaultImageUrl={ViewDefaultImageUrl}
          thumbnailImageUrl={viewInfo.thumbnailUrl}
          ariaLabel={viewInfo.name}
          onResultItemSelected={this.props.onResultItemSelected}
        />

        <div className={CardViewStyles.ActionRow} style={{ marginTop: CommonStyles.Spacing.MediumSpace }}>
          <span data-tb-test-id={ViewCardTestID} className={CardViewStyles.ActionRowName} title={viewInfo.name}>
            {viewInfo.name}
          </span>
          {FeatureFlagService.instance.getValue(FeatureFlag.offspringPostMVP224) ? (
            <span style={{ position: 'relative', bottom: '2px' }}>
              <ConnectedFavoriteToggle searchResultItem={viewInfo} />
            </span>
          ) : null}
          {this.renderInfoIconAndPopover(() => (
            <ViewTooltip content={viewInfo} urls={this.props.urls} />
          ))}
        </div>
        <div data-tb-test-id={ViewCardSubSectionTestID}>
          {viewInfo.owner && (
            <div className={CardViewStyles.SubSection}>
              {Messages.OwnerSubTitle()}{' '}
              <b>
                <UserEntityLink
                  name={viewInfo.owner.displayName}
                  href={this.props.urls.userContentUrl(viewInfo.owner.username, viewInfo.owner.domainName)}
                  styleOverride={CardViewStyles.Links}
                />
              </b>
            </div>
          )}
          {viewInfo.workbook && viewInfo.workbook.name && (
            <div className={CardViewStyles.SubSection}>
              {Messages.workbook()}{' '}
              <b>
                {
                  <EntityLink
                    name={viewInfo.workbook.name}
                    href={this.props.urls.workbookUrl(viewInfo?.workbook?.id)}
                    styleOverride={CardViewStyles.Links}
                  />
                }
              </b>
            </div>
          )}
        </div>
      </div>
    );
  }
}
